import {createSlice} from '@reduxjs/toolkit';
import {defaults} from 'lodash';

const initialState = {
  loading: false,
  error: null,
  filtersData: null,
  globalViewData: {
    totalCorporates: 0,
    totalFacilities: 0,
    totalCo2: 0,
    totalScope1Co2: 0,
    totalScope2Co2: 0,
    totalNetEnergyConsumed: 0,
    totalEnergyConsumed: 0,
    totalEnergyProduced: 0,
  },
  ownerCorporates: {
    loading: false,
    error: null,
    data: [],
  },
  selectedCorporate: null,
  corporateFacilites: {
    loading: false,
    error: null,
    data: [],
  },
  facilityDetails: {
    loading: false,
    error: null,
    data: [],
  },
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    fetchOwnerDashboardFiltersRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOwnerDashboardFiltersSuccess: (state, {payload}) => {
      const {data} = payload;
      state.loading = false;
      state.filtersData = data;
    },
    fetchOwnerDashboardFiltersError: (state, {payload}) => {
      state.loading = false;
      state.error = payload;
    },
    fetchOwnerDashboardGlobalViewRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOwnerDashboardGlobalViewSuccess: (state, {payload}) => {
      const {data} = payload;
      state.loading = false;
      state.globalViewData = defaults(data, initialState.globalViewData);
    },
    fetchOwnerDashboardGlobalViewError: (state, {payload}) => {
      state.loading = false;
      state.error = payload;
    },
    fetchOwnerDashboardCorporatesRequest: (state) => {
      state.ownerCorporates.loading = true;
      state.error = null;
    },
    fetchOwnerDashboardCorporatesSuccess: (state, {payload}) => {
      const {data} = payload;
      state.ownerCorporates.loading = false;
      state.ownerCorporates.data = data;
    },
    fetchOwnerDashboardCorporatesError: (state, {payload}) => {
      state.ownerCorporates.loading = false;
      state.ownerCorporates.error = payload;
    },
    selectCorporate: (state, {payload}) => {
      state.selectedCorporate = payload;
    },
    fetchOwnerDashboardCorporateFacilitiesRequest: (state) => {
      state.corporateFacilites.loading = true;
      state.error = null;
    },
    fetchOwnerDashboardCorporateFacilitiesSuccess: (state, {payload}) => {
      const {data} = payload;
      state.corporateFacilites.loading = false;
      state.corporateFacilites.data = data;
    },
    fetchOwnerDashboardCorporateFacilitiesError: (state, {payload}) => {
      state.corporateFacilites.loading = false;
      state.corporateFacilites.error = payload;
    },

    fetchOwnerDashboardCorporateFacilityDetailsRequest: (state) => {
      state.facilityDetails.loading = true;
      state.error = null;
    },
    fetchOwnerDashboardCorporateFacilityDetailsSuccess: (state, {payload}) => {
      const {data} = payload;
      state.facilityDetails.loading = false;
      const found = state.facilityDetails.data.findIndex(
        (item) => item.id === data.id
      );
      if (found >= 0) {
        state.facilityDetails.data[found] = data;
      } else {
        state.facilityDetails.data.push(data);
      }
    },
    fetchOwnerDashboardCorporateFacilityDetailsError: (state, {payload}) => {
      state.facilityDetails.loading = false;
      state.facilityDetails.error = payload;
    },
  },
});

export const {
  fetchOwnerDashboardFiltersRequest,
  fetchOwnerDashboardFiltersSuccess,
  fetchOwnerDashboardFiltersError,
  fetchOwnerDashboardGlobalViewRequest,
  fetchOwnerDashboardGlobalViewSuccess,
  fetchOwnerDashboardGlobalViewError,
  fetchOwnerDashboardCorporatesRequest,
  fetchOwnerDashboardCorporatesSuccess,
  fetchOwnerDashboardCorporatesError,
  selectCorporate,
  fetchOwnerDashboardCorporateFacilitiesRequest,
  fetchOwnerDashboardCorporateFacilitiesSuccess,
  fetchOwnerDashboardCorporateFacilitiesError,
  fetchOwnerDashboardCorporateFacilityDetailsRequest,
  fetchOwnerDashboardCorporateFacilityDetailsSuccess,
  fetchOwnerDashboardCorporateFacilityDetailsError,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
